import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { userReducer } from '@/state/slice/userSlice';
import { transactionsReducer } from '@/state/slice/transactionsSlice';
import { posReducer } from '@/state/slice/posSlice';
import { dealReducer } from '@/state/slice/dealSlice';
import { privilegeReducer } from '@/state/slice/privilegeSlice';
import { milesConversionReducer } from '@/state/slice/milesConversionSlice';
import { redemptionReducer } from '@/state/slice/redemptionsSlice';
import { redemptionDetailReducer } from '@/state/slice/redemptionSlice';
import { transactionDetailReducer } from '@/state/slice/transactionDetailSlice';
import { dealDetailReducer } from '@/state/slice/dealDetailSlice';
import { privilegeDetailReducer } from '@/state/slice/privilegeDetailSlice';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { maintenanceReducer } from '@/state/slice/maintenanceSlice';
import { challengeReducer } from '@/state/slice/challengeSlice';

const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	timeout: 2000,
	whitelist: ['transactionsState', 'redemptionState', 'userState', 'dealState', 'privilegeState', 'maintenanceState', 'challengeState'],
};

const rootReducer = combineReducers({
	userState: userReducer,
	transactionsState: transactionsReducer,
	transactionDetailState: transactionDetailReducer,
	posState: posReducer,
	redemptionState: redemptionReducer,
	redemptionDetailState: redemptionDetailReducer,
	dealState: dealReducer,
	dealDetailState: dealDetailReducer,
	privilegeState: privilegeReducer,
	milesConversionState: milesConversionReducer,
	privilegeDetailState: privilegeDetailReducer,
	maintenanceState: maintenanceReducer,
	challengeState: challengeReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	devTools: process.env.NODE_ENV !== 'production',
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;

export default store;
